/** 文本消息时,原文和翻译文本的分割符号 */
export const textMsgSeperator = '\t\n\t\n';

/** 聊天消息数据在本地消息表的`cnt`字段转换, 只处理`文本,商品编号`消息 */
export function cntMsgToLocalDbCnt(msg: Conversation.Message) {
  if (msg.messageType === 'TEXT') {
    let transText = '';
    if (msg.textContent?.translationContent) {
      const arr: string[] = [];
      Object.values(msg.textContent.translationContent).forEach((t) => {
        arr.push(t.text);
      });
      transText = arr.join(textMsgSeperator);
    } else if (msg.textContent?.originalText) {
      transText = msg.textContent.originalText;
    }
    return `${msg.textContent?.text || ''}${textMsgSeperator}${transText}`;
  }
  if (msg.messageType === 'ITEM') {
    return `${msg.itemContent?.externalItemId}${msg.channel}` || '';
  }
  if (msg.messageType === 'ORDER') {
    return `${msg.orderContent?.orderSn || ''}`;
  }
  return '';
}
